import { render } from "./InvestBuy.vue?vue&type=template&id=7222be99&scoped=true"
import script from "./InvestBuy.vue?vue&type=script&lang=js"
export * from "./InvestBuy.vue?vue&type=script&lang=js"

import "./InvestBuy.vue?vue&type=style&index=0&id=7222be99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7222be99"]])

export default __exports__